import Vue from "vue";
import { customersClient } from "@api/customers";

const initialState = () => ({
  customers: [],
  pagination: {
    pageNum: 1,
    pageSize: 10,
    totalCount: 0,
    rowsPerPageItems: [10, 20, 30, 40, 50, 100]
  },
  promises: {
    customersFetchPromise: undefined,
    customersSavePromise: undefined,
    customersDeletePromise: undefined
  }
});

export default {
  namespaced: true,
  state: initialState(),
  getters: {
    list: state => state.customers,
    customersFetching: state =>
      state.promises.customersFetchPromise !== undefined,
    customersSaving: state => state.promises.customersSavePromise !== undefined,
    customerDeleting: state =>
      state.promises.customersDeletePromise !== undefined,
    pagination: state => state.pagination
  },
  mutations: {
    reset(state) {
      const initial = initialState();
      Object.keys(initial).forEach(k => {
        state[k] = initial[k];
      });
    },
    setCustomers(state, { customers, totalCount }) {
      state.customers = customers;
      Vue.set(state.pagination, "totalCount", totalCount);
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },

    deleteCustomerById(state, customerId) {
      const index = state.customers.findIndex(x => x.id === customerId);
      if (index >= 0) {
        state.customers.splice(index, 1);
      } else throw Error(`Wrong customer id: ${customerId}`);
    },
    customersFetchPromise(state, promise) {
      state.promises.customersFetchPromise = promise;
    },
    customersSavePromise(state, promise) {
      state.promises.customersSavePromise = promise;
    },
    customersDeletePromise(state, promise) {
      state.promises.customersDeletePromise = promise;
    }
  },
  actions: {
    getCustomer(ctx, id) {
      if (ctx.getters.customersFetching) return;
      const promise = customersClient
        .getCustomer(id)
        .then(resp => {
          ctx.commit("customersFetchPromise", undefined);
          return resp;
        })
        .catch(error => {
          ctx.commit("customersFetchPromise", undefined);
          throw error;
        });
      ctx.commit("customersFetchPromise", promise);
      return promise;
    },
    addCustomer(ctx, customer) {
      if (ctx.getters.customersSaving) return;
      const promise = customersClient
        .postCustomer(customer)
        .then(resp => {
          // debugger
          ctx.commit("customersSavePromise", undefined);
          return resp;
        })
        .catch(error => {
          ctx.commit("customersSavePromise", undefined);
          throw error;
        });
      ctx.commit("customersSavePromise", promise);
      return promise;
    },
    addCustomerSecretKey(ctx, { id }) {
      if (ctx.getters.customersSaving) return;
      const promise = customersClient
        .putCustomerSecretKey(id)
        .then(resp => {
          // debugger
          ctx.commit("customersSavePromise", undefined);
          return resp;
        })
        .catch(error => {
          ctx.commit("customersSavePromise", undefined);
          throw error;
        });
      ctx.commit("customersSavePromise", promise);
      return promise;
    },
    saveCustomer(ctx, { id, customer }) {
      if (ctx.getters.customersSaving) return;
      const promise = customersClient
        .putCustomer(id, customer)
        .then(resp => {
          ctx.commit("customersSavePromise", undefined);
          return resp;
        })
        .catch(error => {
          ctx.commit("customersSavePromise", undefined);
          throw error;
        });
      ctx.commit("customersSavePromise", promise);
      return promise;
    },
    fetchCustomers(ctx) {
      if (ctx.getters.customersFetching) return;
      const { pageNum, pageSize } = ctx.state.pagination;
      const promise = customersClient
        .getCustomers(pageNum, pageSize)
        .then(resp => {
          const { customers, totalCount } = resp.data;
          ctx.commit("customersFetchPromise", undefined);
          ctx.commit("setCustomers", {
            customers,
            totalCount
          });
          return resp;
        })
        .catch(error => {
          ctx.commit("customersFetchPromise", undefined);
          throw error;
        });
      ctx.commit("customersFetchPromise", promise);
      return promise;
    },
    deleteCustomer(ctx, { id }) {
      if (ctx.getters.customerDeleting) return;
      const promise = customersClient
        .deleteCustomer(id)
        .then(resp => {
          ctx.commit("customersDeletePromise", undefined);
          ctx.commit("deleteDustomerById", id);
          return resp;
        })
        .catch(error => {
          ctx.commit("customersDeletePromise", undefined);
          throw error;
        });
      ctx.commit("customersDeletePromise", promise);
      return promise;
    }
  }
};



// WEBPACK FOOTER //
// ./src/state/customers-module.js